import * as React from 'react';
import { FullScreenSpinner } from 'smoothie';

import Roadmap from '../../../roadmap/components/Roadmap';
import { RoadmapMoneySystem } from '../../../roadmap/components/RoadmapMoneySystem';
import { useRoadmapTabExperience } from '../../../roadmap/hooks/useRoadmapTabExperience';

export default function RoadmapTab() {
    const tabExperience = useRoadmapTabExperience();

    if (tabExperience === 'loading') {
        return <FullScreenSpinner />;
    }

    return tabExperience === 'money_system' ? (
        <RoadmapMoneySystem />
    ) : (
        <Roadmap />
    );
}
